import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Marta R.',
    age: 52,
    result: '-4kg y claridad mental',
    text: 'A los 52 años pensaba que mi abdomen nunca volvería a ser el mismo. En 14 días con El Código Hormonal, la inflamación desapareció y por fin volví a dormir 8 horas seguidas. ¡He recuperado mi energía!'
  }, {
    name: 'Laura G.',
    age: 47,
    result: 'Adiós a la neblina mental',
    text: 'Lo que más me gusta es que no paso hambre. Como más que antes, pero como lo que mis hormonas necesitan. Mis sofocos han bajado un 90%.'
  }];
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-239">
      <div className="max-w-5xl mx-auto" data-id="element-240">
        <div className="text-center mb-16" data-id="element-241">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-brand-green" data-id="element-242">
            Historias Reales. Resultados Reales.
          </h2>
          <div className="flex justify-center gap-1" data-id="element-243">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-brand-gold text-brand-gold" data-id="element-244" />)}
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-245">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-white p-8 rounded-3xl shadow-md relative" data-id="element-246">
              <Quote className="absolute top-6 right-6 w-12 h-12 text-brand-cream" data-id="element-247" />
              <div className="flex gap-1 mb-6" data-id="element-248">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-249" />)}
              </div>
              <p className="text-lg text-brand-gray/80 italic mb-8 relative z-10 font-body" data-id="element-250">
                "{t.text}"
              </p>
              <div className="border-t border-brand-cream pt-6" data-id="element-251">
                <p className="font-bold text-brand-green text-lg" data-id="element-252">
                  {t.name}, {t.age} años
                </p>
                <p className="text-sm text-brand-gold font-semibold uppercase tracking-wider mt-1" data-id="element-253">
                  Resultado: {t.result}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}